import { render, staticRenderFns } from "./dropDownLanguages.vue?vue&type=template&id=55cf2cc2&scoped=true&"
import script from "./dropDownLanguages.vue?vue&type=script&lang=js&"
export * from "./dropDownLanguages.vue?vue&type=script&lang=js&"
import style0 from "./dropDownLanguages.vue?vue&type=style&index=0&id=55cf2cc2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55cf2cc2",
  null
  
)

export default component.exports